import styled from 'styled-components';
import React from 'react';
import { Icon } from '@workboard/action-item';
import { getAiTypeAttributes, getStateComponentIcon, getStateObjectLabel } from '../../../utils';
import StateListComp from './stateList';
import RagListComp from './ragList';
import PriorityListComp from './priorityList';
import EffortListComp from './effortList';

const InLineStateListWrapper = styled.div`
  display: flex;
  gap: 5px;
  font-size: 12px;
  color: #333;
`;

type InLineStateListProps = {
  name: string;
  type: string | number;
  value: string | number;
  actId: string;
  tagId: string;
  isAttrAccess: boolean;
  isShowListPopup: boolean;
  onShowListPopup: (view: string, access: boolean) => void;
  onHideListPopup: () => void;
  columnId: string;
  dispatchAction: () => void
}

export function InLineStateList({
  name,
  type,
  actId,
  tagId,
  value,
  isAttrAccess = false,
  isShowListPopup = false,
  onShowListPopup,
  onHideListPopup,
  columnId,
  dispatchAction
}: InLineStateListProps) {
  const { attributes } = getAiTypeAttributes(type);
  const { values } = attributes?.[name];
  const stateIconName = getStateComponentIcon(values, value);

  const ListComp = (props) => {
    switch (name) {
      case 'state':
        return <StateListComp {...props} />;
      case 'rag':
        return <RagListComp {...props} />;
      case 'priority':
        return <PriorityListComp {...props} />;
      case 'effort':
        return <EffortListComp {...props} />;
      default:
        return null
    }
  }

  return (
    <InLineStateListWrapper
      className="clickable"
      data-perm-value={isAttrAccess}
      onClick={() => onShowListPopup(name, isAttrAccess)}
    >
      <div
        className="wsBoardAiAttrImg displayInlineB"
        data-value={value}
      >
        <div>
          <Icon name={stateIconName} width="16" height="16" />
        </div>
        <div className="wsBoardAiAttrListDiv wsBoardAiAttr">
          {isShowListPopup && (
            <ListComp
              hideShowListPopup={onHideListPopup}
              aiId={actId}
              tagId={tagId}
              dispatch={dispatchAction}
              srcVal="act"
              columnId={columnId}
              values={values}
            />
          )}
        </div>
      </div>
      <div className="displayInlineB">
        {getStateObjectLabel(values, value)}
      </div>
    </InLineStateListWrapper>
  )
}
